import RankTypes from './types';
import { Reducer } from 'redux';
import { ServersRankState, ServersRankDispatchAction } from './state';

const initialState : ServersRankState = {
    rank: ''
}

const RankReducer : Reducer<ServersRankState, ServersRankDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case RankTypes.FETCH_START:
                return state
            case RankTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default RankReducer;